import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { ContentContainer, DesertBackground } from "@faire/retailer-visitor-shared/views/about/components/common";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var HeaderModule = function() {
    var spacerHeight = {
        mobileAndAbove: 64,
        tabletAndAbove: 136,
        desktopAndAbove: 120
    };
    return /*#__PURE__*/ _jsx(DesertBackground, {
        children: /*#__PURE__*/ _jsxs(ContentContainer, {
            align: {
                tabletAndAbove: "center",
                mobileAndAbove: "flex-start"
            },
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: spacerHeight
                }),
                /*#__PURE__*/ _jsx(SlideIn, {
                    offset: "30px",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.inverse,
                        variant: "subheadingSansMedium",
                        as: "h1",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "pqfcnL",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "About Us"
                                }
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(SlideIn, {
                    offset: "45px",
                    children: /*#__PURE__*/ _jsx(MaxWidthTypography, {
                        variant: {
                            mobileAndAbove: "displayMSerifRegular",
                            desktopAndAbove: "displayLSerifRegular"
                        },
                        color: Core.text.inverse,
                        align: {
                            tabletAndAbove: "center",
                            mobileAndAbove: "unset"
                        },
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "iPy6qy",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Faire's mission is to empower brands and retailers to strengthen the unique character of local communities."
                                }
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: spacerHeight
                })
            ]
        })
    });
};
var MaxWidthTypography = styled(Typography).withConfig({
    componentId: "sc-53c898bc-0"
})([
    "max-width:552px;",
    "{max-width:716px;}"
], responsiveMediaQueries.desktopAndAbove);
